//* Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

//* Add the Web App's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCHtJeinuH9AGiz7xYdCb4Uumel1HW6cbY",
  authDomain: "granny-battles.firebaseapp.com",
  projectId: "granny-battles",
  storageBucket: "granny-battles.firebasestorage.app",
  messagingSenderId: "1083865731253",
  appId: "1:1083865731253:web:eeddcbea6641a101beaefc",
  measurementId: "G-2BWQVYMVHS",
};

//* Initialize Firebase
let firebase_app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

//* Initialize Firebase Auth and set persistence
const auth = getAuth(firebase_app);
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Session persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Failed to set session persistence:", error);
  });

export { auth };
export default firebase_app;
